export default __webpack_public_path__ + "static/3-f3073147c78aea35f91cfa777634050f.jpeg";